import style from '../yeah.module.scss'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'
import { IProductItemYeah } from '../yeah.state'
import Image from 'next/image';

interface IProductSectionProps {
    title: string;
    subtitle: string;
    productItems: Array<IProductItemYeah>;
    imageSrc: string;
    imageAlt: string;
}

const ProductSectionYeah = ({ title, subtitle, productItems, imageSrc, imageAlt }: IProductSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_px80}`}>
            <div className={`${style.container} ${style.product}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.title} ${style.title_middle} ${animations.scroll__animation} ${style.text_align_c} ${style.mb24}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.text} ${animations.scroll__animation} ${style.text_middle} ${style.text_align_c} ${style.product__subtitle}`}>
                                {subtitle}
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.product__items} ${animations.scroll__animation} ${style.mb60}`}>
                                {
                                    productItems.map((item: IProductItemYeah, index: number) => {
                                        return (
                                            <div className={`${style.product__item}`} key={index}>
                                                <div className={`${style.product__item__icon} ${style.mb16}`}>
                                                    <Image alt={item.title} src={item.icon} width={item.width} height={item.height} />
                                                </div>
                                                <div className={`${style.title} ${style.title_small} ${style.mb6}`}>
                                                    {item.title}
                                                </div>
                                                <div className={`${style.text} ${style.text_small}`}>
                                                    {item.subtitle}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.image} ${animations.scroll__animation} ${style.image_product}`}>
                                <Image sizes="800 400 200" src={imageSrc} alt={imageAlt} layout={'fill'} />
                            </div>
                        )
                    }}
                </InView>
            </div>
        </section>
    )
}

export default ProductSectionYeah;
